export class EClientError extends Error {
  constructor(message = 'Something went wrong. Please try again.') {
    super(message);
    this.name = 'EClientError';
  }
}
